module.exports = __webpack_public_path__ + "static/rainbowteether-9209296d772e8abcb1940ba2de9d0d98.png";